/** Ground wetness easing: soaks up over ~20 s of rain, dries over ~60 s once it stops. */
export const WET_RISE_SECONDS = 20;
export const WET_DRY_SECONDS = 60;

/** Step the smoothed wetness (0..1) towards `target` (0..1) over dt seconds. */
export function easeWetness(w: number, target: number, dt: number): number {
  if (target > w) return Math.min(target, w + dt / WET_RISE_SECONDS);
  return Math.max(target, w - dt / WET_DRY_SECONDS);
}
